var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return typeof _vm.price === "number" || _setup.isPriceTelemedMedtochkaVisible
    ? _c(
        "div",
        {
          attrs: {
            "data-appointment-type-redirect": _setup.redirectValue,
            "data-qa": "doctor_price_block",
          },
        },
        [
          _setup.isPriceFreeVisible
            ? _c(_setup.PriceFreeByCondition, { attrs: { price: _vm.price } })
            : _setup.isPriceClubVisible
            ? _c(_setup.PriceWithClub, {
                attrs: { "club-price": _vm.clubPrice, price: _vm.price },
                on: { "click:show-info": _setup.handleClickShowClubInfoModal },
              })
            : _setup.isPriceClinicVisible
            ? _c(_setup.PriceClinic, { attrs: { price: _vm.price } })
            : _setup.isPriceTelemedMedtochkaVisible
            ? _c(_setup.PriceTelemed, {
                attrs: {
                  price: _vm.telemedMedtochkaPrice,
                  "speciality-selected": _vm.specialitySelected,
                },
              })
            : _setup.isPriceTelemedVisible
            ? _c(_setup.PriceTelemed, {
                attrs: {
                  price: _vm.price,
                  "speciality-selected": _vm.specialitySelected,
                },
              })
            : _setup.isPriceHomeVisible
            ? _c(_setup.PriceHome, { attrs: { price: _vm.price } })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }